import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Create axios instance with auth interceptor
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// OTDR API Service
export const otdrService = {
  // OTDR Configurations
  async createConfig(configData) {
    const response = await api.post('/otdr/configs', configData);
    return response.data;
  },

  async getConfigs(projectId) {
    const response = await api.get(`/otdr/configs/project/${projectId}`);
    return response.data;
  },

  async getConfigsByProject(projectId) {
    const response = await api.get(`/otdr/configs/project/${projectId}`);
    return response.data;
  },

  async getConfig(configId) {
    const response = await api.get(`/otdr/configs/${configId}`);
    return response.data;
  },

  async updateConfig(configId, configData) {
    const response = await api.put(`/otdr/configs/${configId}`, configData);
    return response.data;
  },

  async deleteConfig(configId) {
    const response = await api.delete(`/otdr/configs/${configId}`);
    return response.data;
  },

  // Credentials
  async uploadCredentials(configId, file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/otdr/configs/${configId}/upload-credentials`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Connection Testing
  async testConnection(configId, sheetName = null) {
    const params = sheetName ? { sheet_name: sheetName } : {};
    const response = await api.post(`/otdr/configs/${configId}/test-connection`, {}, { params });
    return response.data;
  },

  // Data Synchronization
  async syncData(configId) {
    const response = await api.post(`/otdr/configs/${configId}/sync`);
    return response.data;
  },

  async syncFromSheets(configId) {
    const response = await api.post(`/otdr/configs/${configId}/sync`);
    return response.data;
  },

  // Analytics
  async getAnalytics(projectId, startDate, endDate) {
    const response = await api.get(`/otdr/analytics/${projectId}`, {
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  },

  // Shipments
  async getShipments(projectId, startDate = null, endDate = null, skip = 0, limit = 1000) {
    const params = { skip, limit };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    
    const response = await api.get(`/otdr/shipments/${projectId}`, { params });
    return response.data;
  },

  async createShipment(shipmentData) {
    const response = await api.post('/otdr/shipments', shipmentData);
    return response.data;
  },

  // Manual Data Fill Methods
  async fillMissingData(projectId, type) {
    const response = await api.post(`/otdr/fill-missing-data/${projectId}`, { type });
    return response.data;
  },

  // Google Sheets helpers
  async listUserSheets(credentialsPath = null) {
    const params = credentialsPath ? { credentials_path: credentialsPath } : {};
    const response = await api.get('/otdr/sheets/list', { params });
    return response.data;
  },

  async getSheetTabs(sheetId, credentialsPath) {
    const response = await api.get(`/otdr/sheets/${sheetId}/tabs`, {
      params: { credentials_path: credentialsPath }
    });
    return response.data;
  }
};

export default otdrService;